import React from 'react';
import PropTypes from 'prop-types';

import {
  TableCell,
  Tooltip,
  TooltipDescription,
} from './styles';

const TableRowColumnDescription = (props) => {
  const { text } = props;

  const isTextLong = text.length > 35;

  // using css only do the 3 dots at one line
  // we could use the -webkit-line-clamp, but we never know how many lines we will have
  const ellipsis = (fullText, length) => {
    if (fullText.length <= length) return fullText;
    return `${fullText.substring(0, length)}...`;
  };

  if (!isTextLong) {
    return (
      <TableCell>
        {ellipsis(text, 35)}
      </TableCell>
    );
  }

  return (
    <Tooltip
      content={(
        <TooltipDescription>
          {text}
        </TooltipDescription>
      )}
      position="top center"
      size="mini"
      trigger={(
        <TableCell>
          {ellipsis(text, 35)}
        </TableCell>
      )}
      wide
    />
  );
};

TableRowColumnDescription.propTypes = {
  text: PropTypes.string.isRequired,
};

export default TableRowColumnDescription;
